import React from 'react';

interface RadioCardOptionProps {
  id: string;
  label: string;
  description: string;
  name: string;
  value: string;
  icon?: string;
}

export function RadioCardOption({ id, label, description, name, value, icon }: RadioCardOptionProps) {
  return (
    <div className="radio-card-button-option">
      <input type="radio" id={id} name={name} value={value} />
      <div className="radio-card-button-content">
        <div className="radio-card-button-header">
          { icon && <span className="material-symbols-outlined">{icon}</span> }
          <h4>{label}</h4>
        </div>
        <h6>{description}</h6>
      </div>
    </div>
  );
}
